import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

import { DELAYS } from 'utils/constants';

import { Countdown } from './countdown';

export function Redirecting({
  data = {}
}: {
  data?: { location?: string; action?: string };
}): JSX.Element {
  const history = useHistory();
  const [, { language }] = useTranslation();
  const [count, setCount] = React.useState(DELAYS.loginCountdown / 1000);
  const [t] = useTranslation();

  const countdown = React.useMemo(
    () =>
      new Countdown({
        redirectToLoginPage: () => history.push(`/${language}`),
        onTick: (newValue) => setCount(newValue)
      }),
    []
  );

  React.useEffect(() => {
    countdown.setRedirectData(data);
    countdown.start(count);
    return () => countdown.cleanup();
  }, [countdown]);

  return (
    <p>
      {`${t('labels.redirecting', { countdown: count })} `}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        to="#"
        onClick={(event) => {
          event.preventDefault();
          countdown.skipCountdown();
          return false;
        }}
      >
        {t('forms.redirect_now')}
      </Link>
    </p>
  );
}
